var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-data-cell"},[_c('div',{staticClass:"date-data-container"},[(_vm.isLeaked)?_c('div',{staticClass:"date-data-container__leak-date"},[_vm._v(" "+_vm._s(_vm.item.leakDate)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }